import { routeNames, routePaths } from '@/router/router-constants'
import type { RouteRecordRaw } from 'vue-router'

export const deadlineTypeRoutes: RouteRecordRaw[] = [
  {
    path: routePaths.deadlineTypes,
    component: () => import('@/pages/deadline-types/DeadlineConfigurationsView.vue'),
    meta: {
      permission: 'deadline-types.read.all',
      rootRouteName: routeNames.deadlineTypes,
      featureFlag: 'deadlines',
      icon: 'material-symbols-outlined',
      iconText: 'edit_calendar',
      labelKey: 'deadlineTypes',
    },
    children: [
      {
        path: '',
        name: routeNames.deadlineTypes,
        component: () => import('@/pages/deadline-types/DeadlineTypesTab.vue'),
      },
      {
        path: routePaths.deadlineBadges,
        name: routeNames.deadlineBadges,
        component: () => import('@/pages/deadline-types/DeadlineBadgesTab.vue'),
        meta: {
          permission: 'deadline-badges.write.all',
          labelKey: 'deadlineBadges',
        },
      },
    ],
  },
]
